const additionalService = document.querySelector(
  "[data-js='additionalService']"
);
const additionalServiceInput = document.querySelector("#f-additional-service");
const additionalServiceSubmit = document.querySelector(
  "#submit-additional-service"
);
const additionalServiceReset = document.querySelector(
  "#reset-additional-service"
);

const asSubsBtn = document.querySelector(".as-subs-btn");
const asAddBtn = document.querySelector(".as-add-btn");
const asCountEl = document.querySelector(".as-count");

let asCount = 0;

if (additionalService) {
  var bookingForm = document.getElementById("booking-form");

  additionalServiceSubmit.addEventListener("click", function () {
    let asValues = $("input[type='checkbox']:checked")
      .map(function () {
        return $(this).val();
      })
      .get()
      .join(", ");

    additionalServiceInput.value = $("input[class='as-input']")
      .map(function () {
        // Get the name attribute value that you want to change
        var nameAttribute = $(this).attr("name");

        // Get the value attribute value that you want to set
        var valueAttribute = $(this).attr("value");

        // Find the input element by name attribute
        var inputElement = bookingForm.querySelector(
          'input[name="' + nameAttribute + '"]'
        );
        console.log(inputElement);
        // Check if the input element with the specified name exists
        if (inputElement) {
          // Update the value of the input element
          inputElement.value = valueAttribute;
        }
        if ($(this).attr("value") > 0) {
          return (
            $(this).attr("value") + "x " + $(this).attr("data-name-localized")
          );
        }
      })
      .get()
      .join(", ");
    // console.log($(this));
    formData = new FormData(bookingForm);
    const data = JSON.stringify(Object.fromEntries(formData.entries()));
    //  console.log(formData);
    bookingForm.submit();

    //$("input[type='hidden']").map(function () { return $(this).val(); }).join(", ");
  });

  additionalServiceReset.addEventListener("click", function () {
    $("input[type='checkbox']:checked").prop("checked", false);
    asCount = 0;
    updateCountValues();
    additionalServiceInput.value = "";
  });

  document.querySelectorAll(".as-change").forEach((item) => {
    item.addEventListener("click", (event) => {
      var counter = event.target.getAttribute("data-field");
      //   console.log(counter);
      if (event.target.classList.contains("btn-plus")) {
        $("#" + counter).val(parseInt($("#" + counter).val()) + 1);
      }
      if (event.target.classList.contains("btn-minus")) {
        if ($("#" + counter).val() > 0)
          $("#" + counter).val(parseInt($("#" + counter).val()) - 1);
        // if ($("#" + counter).val() == 0) event.target.classList.add("disabled");
      }

      $("." + counter).html($("#" + counter).val());
      // console.log($("." + counter));
    });
  });
}
